export const MODIFY_CUSTOM_CONTACT_FILES = 'MODIFY_CUSTOM_CONTACT_FILES';

export function modifyCustomContactFiles(customContactFiles){
    return{
        type: MODIFY_CUSTOM_CONTACT_FILES,
        mainState: {
            customContactFiles: customContactFiles
        }
    }
}